import Header from '../components/Header'
import Footer from '../components/Footer'

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="bg-white">
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Privacy Policy
              </h1>
              <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
                Last Updated: June 15, 2023
              </p>
            </div>

            <div className="prose prose-lg text-gray-500 mx-auto">
              <h2 className="text-2xl font-bold text-gray-900">1. Introduction</h2>
              <p>
                TheMarketingFeeds.com ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">2. Information We Collect</h2>
              <p>We may collect the following types of information:</p>
              <ul className="list-disc pl-6">
                <li><strong>Personal Information:</strong> Name, email address, phone number, company name when you fill out forms or contact us</li>
                <li><strong>Usage Data:</strong> IP address, browser type, pages visited, time spent on pages</li>
                <li><strong>Cookies:</strong> We use cookies to improve your experience and analyze site traffic</li>
                <li><strong>Marketing Data:</strong> Information about your preferences for receiving marketing communications</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">3. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6">
                <li>Provide and maintain our services</li>
                <li>Improve and personalize your experience</li>
                <li>Communicate with you about services, updates, and offers</li>
                <li>Analyze usage trends and optimize our website</li>
                <li>Prevent fraud and enhance security</li>
                <li>Comply with legal obligations</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">4. Data Sharing and Disclosure</h2>
              <p>We may share information with:</p>
              <ul className="list-disc pl-6">
                <li>Service providers who assist with our business operations</li>
                <li>Business partners for co-marketing initiatives (with your consent)</li>
                <li>Legal authorities when required by law</li>
                <li>Successors in the event of a merger or acquisition</li>
              </ul>
              <p className="mt-4">
                We never sell your personal information to third parties.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">5. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal data, including:
              </p>
              <ul className="list-disc pl-6">
                <li>SSL/TLS encryption for data transmission</li>
                <li>Regular security assessments</li>
                <li>Access controls and authentication procedures</li>
                <li>Employee privacy training</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">6. Your Rights</h2>
              <p>Depending on your location, you may have the right to:</p>
              <ul className="list-disc pl-6">
                <li>Access, correct, or delete your personal information</li>
                <li>Opt-out of marketing communications</li>
                <li>Restrict or object to processing of your data</li>
                <li>Data portability</li>
                <li>Withdraw consent where applicable</li>
              </ul>
              <p className="mt-4">
                To exercise these rights, please contact us at privacy@themarketingfeeds.com.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">7. Cookies and Tracking Technologies</h2>
              <p>
                We use cookies and similar tracking technologies to:
              </p>
              <ul className="list-disc pl-6">
                <li>Remember user preferences</li>
                <li>Analyze website traffic</li>
                <li>Deliver targeted advertisements</li>
              </ul>
              <p className="mt-4">
                You can control cookies through your browser settings. Disabling cookies may affect certain website features.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">8. International Data Transfers</h2>
              <p>
                Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for these transfers.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">9. Children's Privacy</h2>
              <p>
                Our services are not directed to individuals under 16. We do not knowingly collect personal information from children.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">10. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy periodically. We will notify you of significant changes by posting the new policy on our website.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">11. Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <address className="not-italic mt-2">
                TheMarketingFeeds.com<br />
                Attn: Privacy Officer<br />
                123 Marketing Street<br />
                New York, NY 10001<br />
                Email: hello@themarketingfeeds.com<br />
                Phone: (555) 123-4567
              </address>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Privacy